module.exports = __webpack_public_path__ + "faca9ee0e5dddc4fb77245f0e339bbfb.webp";